import React, { FunctionComponent, useState, useRef } from "react";
import MapMarkerProps from "./MapMarkerProps.interface";
import { Marker, InfoWindow } from "@react-google-maps/api";
import Paragraph from "components/Paragraph/Paragraph";
import styles from "./MapMarker.module.scss";
import useOnClickOutside from "../../hooks/useOnClickOutside";

const MapMarker: FunctionComponent<MapMarkerProps> = (props) => {
    const { marker, markerWidth, markerHeight, markerImageFallback, showClusters, clusterer } = props;
    const [showInfoWindow, setShowInfoWindow] = useState(false);
    const ref = useRef(null);

    const handleClickOutside = (e: any) => {
        const checkIfPng = e?.target?.src?.substr(e.target.src.length - 3);
        if (showInfoWindow && checkIfPng === "png") {
            setShowInfoWindow(false);
        }
    };

    useOnClickOutside(ref, handleClickOutside);

    return (
        <Marker onClick={() => { setShowInfoWindow(!showInfoWindow); }} icon={{ url: marker?.content?.customMarker?._url ? marker.content.customMarker._url : markerImageFallback ? markerImageFallback : "", scaledSize: new window.google.maps.Size(markerWidth, markerHeight), origin: new window.google.maps.Point(0, 0), anchor: new window.google.maps.Point(markerWidth / 2, markerHeight), }} position={{ lat: Number(marker.content.latitude), lng: Number(marker.content.longitude) }} clusterer={showClusters ? clusterer : undefined}>
            {showInfoWindow && marker.content.infoWindowContent ? (
                <InfoWindow onCloseClick={() => setShowInfoWindow(false)} options={{ pixelOffset: new window.google.maps.Size(0, 0) }}>
                    <div ref={ref}>
                        <Paragraph className={styles.text} innerHTML={marker.content.infoWindowContent} />
                    </div>
                </InfoWindow>
            ) : null}
        </Marker>
    );
};

export default MapMarker;
